import { categoriesArrayType } from '@/components/pages/notifications/types';

export const NOTIFICATION_CATEGORY_ANALYTICS = 'analytics';
export const NOTIFICATION_CATEGORY_COLLABORATION = 'collaboration';
export const NOTIFICATION_CATEGORY_CONTENT = 'content';
export const NOTIFICATION_CATEGORY_CONVERSATIONS = 'conversations';
export const NOTIFICATION_CATEGORY_DASHBOARD = 'dashboard';
export const NOTIFICATION_CATEGORY_REPORTS = 'reports';
export const NOTIFICATION_CATEGORY_SUBSCRIPTION = 'subscription';
export const NOTIFICATION_CATEGORY_USERS_ROLES = 'users_and_roles';

export type CategoryOptionType = {
    label: string;
} & ({ value: 'all' } | { value: categoriesArrayType; icon: string });

export const categoryOptions: CategoryOptionType[] = [
    { label: 'notifications:categories_options.all', value: 'all' },
    {
        label: 'notifications:categories_options.analytics',
        value: NOTIFICATION_CATEGORY_ANALYTICS,
        icon: 'analytics'
    },
    {
        label: 'notifications:categories_options.collaboration',
        value: NOTIFICATION_CATEGORY_COLLABORATION,
        icon: 'collaboration'
    },
    {
        label: 'notifications:categories_options.content',
        value: NOTIFICATION_CATEGORY_CONTENT,
        icon: 'content'
    },
    {
        label: 'notifications:categories_options.conversations',
        value: NOTIFICATION_CATEGORY_CONVERSATIONS,
        icon: 'conversations'
    },
    {
        label: 'notifications:categories_options.dashboard',
        value: NOTIFICATION_CATEGORY_DASHBOARD,
        icon: 'dashboard'
    },
    {
        label: 'notifications:categories_options.reports',
        value: NOTIFICATION_CATEGORY_REPORTS,
        icon: 'reports'
    },
    {
        label: 'notifications:categories_options.subscription',
        value: NOTIFICATION_CATEGORY_SUBSCRIPTION,
        icon: 'paid-data'
    },
    {
        label: 'notifications:categories_options.users_and_roles',
        value: NOTIFICATION_CATEGORY_USERS_ROLES,
        icon: 'single-profile'
    }
];
